<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Btm from "../components/Btm.svelte";
    import * as store from "../stores/store";
    import { get } from "svelte/store";
    import { selectedAs } from "../stores/store";

    export let params;
    let as_id = params.as_id;
    let as_cmpn_id = params.as_cmpn_id;

    let pageSize = 10; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지
    let currentList = [];
    let dataList = [];

    let activeIndex = null;
    let repair_name = "";
    let phone = "";
    let repair_id = "";

    function handleClick(index, name, tel, id) {
        if (activeIndex === index) {
            // 이미 선택된 항목이면 해제
            activeIndex = null;
            repair_name = "";
            phone = "";
            repair_id = "";
        } else {
            activeIndex = index;
            repair_name = name;
            phone = tel;
            repair_id = id;
        }

        console.log(activeIndex);
    }

    // 버튼 배경 색 결정
    $: btnBackground =
        activeIndex !== null
            ? "var(--Color-on, #4E8EED)"
            : "var(--Color-line, #E4E8EA)";

    onMount(() => {
        getData();
    });

    async function getData() {
        currentPage = 0;
        currentList = [];

        const response = await api.get(`/repair/cmpn?cmpn_id=${as_cmpn_id}`);

        if (response != null) {
            dataList = [];
            dataList = response.data;
            loadMore();
        }
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        currentList = [...currentList, ...dataList.slice(start, end)];
        currentPage++;
    }

    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList.length < dataList.length) {
                loadMore();
            }
        }
    }

    async function saveClick() {
        const formData = {
            as_id,
            as_cmpn_id,
            repair_id,
        };

        const response = await api.post("/assignment/put", formData);

        if (response != null) {
            if (Capacitor.isNativePlatform()) {
            }
            push("/AsTimeComplete");
        } else {
            alert(response.msg);
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="main-body custom-repair">
    <div class="main-content">
        <header class="as-header">
            <button class="back-btn" on:click={() => window.history.back()}>
                <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                >
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
            <h1>기사 배정</h1>
        </header>

        <div class="as-list-container scroll-custom" on:scroll={handleScroll}>
            <!-- 선택된 AS 정보 요약 (AsPartner와 동일 스타일) -->
            <div class="selected-as-summary">
                <div class="summary-header">
                    <span class="summary-tag">배정 대상 정보</span>
                </div>
                <div class="summary-body">
                    <div class="summary-row">
                        <span class="s-label">접수처/수리처</span>
                        <span class="s-value">
                            {$selectedAs?.cus_name?.replaceAll("<br>", " / ") ||
                                ""}
                        </span>
                    </div>
                    <div class="summary-row">
                        <span class="s-label">제품명</span>
                        <span class="s-value">
                            {$selectedAs?.item_name || ""}
                        </span>
                    </div>
                </div>
            </div>

            <div class="list-title">작업을 진행할 기사님 선택</div>

            {#each currentList as data, index}
                <div
                    class="as-card-item {activeIndex === index
                        ? 'selected'
                        : ''}"
                    on:click={() =>
                        handleClick(
                            index,
                            data.name,
                            data.phone,
                            data.account_id,
                        )}
                >
                    <div class="as-card-header">
                        <div class="as-driver-info">
                            <span class="as-driver-name">{data.name}</span>
                            <span class="as-driver-label">기사님</span>
                        </div>
                        {#if activeIndex === index}
                            <span class="as-select-badge">선택됨</span>
                        {/if}
                    </div>

                    <div class="as-card-body">
                        <div class="as-info-row">
                            <span class="as-label">연락처</span>
                            <span class="as-value">{data.phone}</span>
                        </div>
                    </div>
                </div>
            {/each}
        </div>

        <div class="as-action-container">
            <button
                class="as-submit-btn"
                class:disabled={activeIndex === null}
                on:click={() => {
                    if (activeIndex != null) {
                        saveClick();
                    }
                }}
            >
                <span>배정 확정하기</span>
                <svg
                    class="as-btn-icon"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    stroke="currentColor"
                    stroke-width="3"
                    fill="none"
                >
                    <path d="M20 6L9 17L4 12"></path>
                </svg>
            </button>
        </div>

        <Btm />
    </div>
</div>

<style>
    .custom-repair.main-body {
        background-color: var(--bg-primary) !important;
        min-height: 100vh;
    }
    .custom-repair .main-content {
        max-width: 1024px;
        margin: 0 auto;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: var(--bg-primary);
    }

    /* Header */
    .custom-repair .as-header {
        background-color: var(--bg-secondary);
        padding: 18px 16px;
        display: flex;
        align-items: center;
        gap: 16px;
        border-bottom: 1px solid var(--border-color);
        position: sticky;
        top: 0;
        z-index: 100;
    }
    .custom-repair .back-btn {
        background: none;
        border: none;
        color: var(--text-primary);
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;
    }
    .custom-repair h1 {
        font-size: 18px;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0;
    }

    /* Summary */
    .custom-repair .selected-as-summary {
        background-color: var(--color-primary-light);
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 24px;
        border: 1px solid var(--color-primary);
    }
    .custom-repair .summary-tag {
        font-size: 11px;
        font-weight: 800;
        color: var(--color-primary);
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 8px;
        display: inline-block;
    }
    .custom-repair .summary-row {
        display: flex;
        margin-bottom: 4px;
    }
    .custom-repair .s-label {
        font-size: 13px;
        color: var(--text-secondary);
        width: 100px;
        flex-shrink: 0;
    }
    .custom-repair .s-value {
        font-size: 14px;
        font-weight: 700;
        color: var(--text-primary);
    }

    .custom-repair .list-title {
        font-size: 15px;
        font-weight: 700;
        color: var(--text-primary);
        margin-bottom: 12px;
        padding-left: 4px;
    }

    /* List */
    .custom-repair .as-list-container {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        padding-bottom: 180px;
    }

    /* Driver Card */
    .custom-repair .as-card-item {
        background-color: var(--bg-secondary);
        border-radius: 12px;
        box-shadow: var(--shadow-sm);
        margin-bottom: 12px;
        overflow: hidden;
        border: 2px solid var(--border-color);
        transition: all 0.2s;
        cursor: pointer;
    }
    .custom-repair .as-card-item.selected {
        border-color: var(--color-primary);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
    }

    .custom-repair .as-card-header {
        padding: 12px 16px;
        background-color: var(--bg-tertiary);
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid var(--border-color);
    }
    .custom-repair .as-card-item.selected .as-card-header {
        background-color: var(--color-primary-light);
        border-bottom-color: var(--color-primary);
    }

    .custom-repair .as-driver-name {
        font-size: 15px;
        font-weight: 700;
        color: var(--text-primary);
    }
    .custom-repair .as-driver-label {
        font-size: 13px;
        color: var(--text-secondary);
        margin-left: 4px;
    }
    .custom-repair .as-select-badge {
        font-size: 11px;
        font-weight: 800;
        background-color: var(--color-primary);
        color: white;
        padding: 2px 8px;
        border-radius: 4px;
    }

    .custom-repair .as-card-body {
        padding: 14px 16px;
    }
    .custom-repair .as-info-row {
        display: flex;
        font-size: 14px;
    }
    .custom-repair .as-label {
        width: 70px;
        color: var(--text-tertiary);
        font-weight: 500;
    }
    .custom-repair .as-value {
        color: var(--text-primary);
    }

    /* Action Button - 최신 스타일 */
    .custom-repair .as-action-container {
        position: fixed;
        bottom: 70px;
        left: 0;
        right: 0;
        padding: 24px 20px 40px;
        max-width: 1024px;
        margin: 0 auto;
        z-index: 100;
        background: linear-gradient(to top, var(--bg-primary) 90%, transparent);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
    }

    .custom-repair .as-submit-btn {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        background: linear-gradient(
            135deg,
            #059669 0%,
            #10b981 100%
        ); /* 성공의 상징 초록색 계열 */
        color: white;
        border: none;
        border-radius: 16px;
        font-size: 18px;
        font-weight: 800;
        cursor: pointer;
        box-shadow: 0 10px 30px -5px rgba(16, 185, 129, 0.4);
        transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    }

    .custom-repair .as-submit-btn:hover:not(.disabled) {
        transform: translateY(-4px);
        box-shadow: 0 15px 40px -5px rgba(16, 185, 129, 0.5);
    }

    .custom-repair .as-submit-btn:active:not(.disabled) {
        transform: translateY(0) scale(0.97);
    }

    .custom-repair .as-submit-btn.disabled {
        background: #94a3b8;
        box-shadow: none;
        cursor: not-allowed;
        opacity: 0.6;
    }
</style>
